const dataStructures = [
    {
        title: "ARRAY",
        color: "turquoise",
    },
    {
        title: "LINKED LIST",
        color: "light-blue",
    },
    {
        title: "STACK",
        color: "orange",
    },
    {
        title: "QUEUE",
        color: "red",
    },
    {
        title: "HASHMAP",
        color: "pink",
    },
    {
        title: "BINARY TREE",
        color: "raspberry",
    },
    {
        title: "GRAPH",
        color: "caribbean-green",
    },
];

export default dataStructures;
